









import { Component, Vue } from 'vue-property-decorator';
import CreateTemplateForm from './components/createTemplateForm.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import {templateListInstance} from '@/model/ModuleTemplateListClass';

type IModuleTemplateParams = IModule.IRequest.IModuleTemplateParams;

@Component({
  components: {
    CreateTemplateForm,
  },
})
export default class CreateTemplate extends Vue {
  private templateListInstance = templateListInstance;
  private createTemplate(templateData: IModuleTemplateParams): Promise<string> {
    return new Promise((reslove, reject) => {
      this.templateListInstance.saveTemplate(templateData).then((res) => {
        reslove(res);
        this.goListPage();
      }).catch((err) => {
        reject(err);
      });
    });
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({
      name: 'Module',
    });
  }
}
